//core modules
import React, {createContext, useContext, useState} from "react";

const SettingsContext = createContext();

const useSettingsContext = () => useContext(SettingsContext);

const SettingsProvider = ({children}) => {

    const [showLoader, setShowLoader] = useState(false);

    return (
        <SettingsContext.Provider value={{
            showLoader,
            setShowLoader,
        }}>
            {children}
        </SettingsContext.Provider>
    );
}

export {useSettingsContext, SettingsProvider};